
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import Pagination from '../Paginations'
import { deleteArtist, getAllArtists } from '../../api/artists'
import { useQuery } from '@tanstack/react-query'
import { CircularProgress, Alert } from '@mui/material'

const AdminArtists = () => {
    const [currentPage, setCurrentPage] = useState(1)
    const deleteSuccess = useRef()
    const errorModal = useRef()

    // Replace useState + useEffect with React Query
    const { data, isLoading, error } = useQuery({
        queryKey: ['artists'],
        queryFn: getAllArtists,
        select: (data) => data.artists.map(artist => ({
            ...artist,
            index: artist.id,
            key: artist.users_profile?.user_id,
            email: artist.users_profile?.email,
            name: artist.name,
            website: artist.website
        }))
    })

    /////////// PAGINATION ///////////
    const itemsPerPage = 25
    const indexOfLastItem = currentPage * itemsPerPage
    const indexOfFirstItem = indexOfLastItem - itemsPerPage
    const currentItems = data ? data.slice(indexOfFirstItem, indexOfLastItem) : []
    const totalPages = data ? Math.ceil(data.length / itemsPerPage) : 0

    const deleteArtistN = async (userKey, artistIndex) => {
        try {
            await deleteArtist(userKey, artistIndex)
            deleteSuccess.current.click()
        } catch (error) {
            errorModal.current.click()
        }
    }

    return (
        <div className="admin-page py-5">
            <div className='container'>
                <h1 className='dash-title'>Artists</h1>
                <div className="row">
                    <div className="col-12 mt-4">
                        <div className="dash-card">
                            <div className="dash-card-heading">
                                <h2 className="dash-card-title">Artists</h2>
                            </div>

                            {/* Loading State */}
                            {isLoading && (
                                <div style={{ display: 'flex', justifyContent: 'center', padding: '50px 0' }}>
                                    <CircularProgress />
                                </div>
                            )}

                            {/* Error State */}
                            {error && (
                                <Alert severity="error" sx={{ margin: '20px 0' }}>
                                    Error loading artists: {error.message}
                                </Alert>
                            )}

                            {/* Data Table */}
                            {!isLoading && !error && (
                                <>
                                    <div className="table-responsive mt-3">
                                        <table className="table dash-table">
                                            <thead>
                                                <tr>
                                                    <td>User</td>
                                                    <td>Name</td>
                                                    <td>Website</td>
                                                    <td>Action</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentItems.map((artist, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            <div className="table-item">
                                                                {artist.email}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="table-item">
                                                                {artist.name}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="table-item">
                                                                {artist.website}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="table-item d-flex">
                                                                <Link
                                                                    to={`edit/${artist.key}/${artist.index}`} 
                                                                    className="table-action-btn a-blue me-1"
                                                                >
                                                                    <i className="fi fi-rr-pencil"></i>
                                                                </Link>
                                                                <i 
                                                                    onClick={() => deleteArtistN(artist.key, artist.index)} 
                                                                    className="fi fi-rr-trash table-action-btn a-red ms-2"
                                                                ></i>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination 
                                        currentPage={currentPage} 
                                        totalPages={totalPages} 
                                        handlePageChange={setCurrentPage} 
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Success Modal */}
            <button ref={deleteSuccess} data-bs-target="#successModal" data-bs-toggle="modal" hidden></button>
            <div className="modal fade" id="successModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="successModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body success-modal">
                            <a className='success-close-btn' href="/admin/artists">
                                <i className="fi fi-rr-cross"></i>
                            </a>
                            <i className="fi fi-rr-check-circle text-success success-icon"></i>
                            <h5>Artist Deleted Successfully!</h5>
                        </div>
                    </div>
                </div>
            </div>

            {/* Error Modal */}
            <button ref={errorModal} data-bs-target="#errorModal" data-bs-toggle="modal" hidden></button>
            <div className="modal fade" id="errorModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="successModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body success-modal">
                            <button className='success-close-btn btn' data-bs-dismiss="modal" aria-label="Close">
                                <i className="fi fi-rr-cross"></i>
                            </button>
                            <i className="fi fi-rr-check-circle text-danger error-icon"></i>
                            <h5>The Artist have releases. please delete the release he has before deleting this artist.</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminArtists